import { styled, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

const StyledTextField = styled(TextField)`
  .Mui-error {
    text-align: right;
  }

  .MuiFormHelperText-root {
    text-align: right;
  }
`;

interface TextFieldCustomProps {
  id: string;
  label: string;
  control: any;
  select?: boolean;
  type: string;
  autocomplete?: string;
  inputMode?: string;
  helperText?: string;
}

export const TextFieldCustom = ({
  id,
  label,
  select,
  control,
  type,
  autocomplete,
  inputMode,
  helperText = "",
}: TextFieldCustomProps) => {
  return (
    <Controller
      name={id}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <StyledTextField
            {...field}
            error={!!error}
            color="secondary"
            helperText={error ? error.message : helperText}
            label={label}
            type={type}
            autoComplete={autocomplete}
            variant="standard"
            InputProps={{
              style: { textAlign: "right" },
            }}
            inputProps={{
              inputMode: inputMode === "numeric" ? "numeric" : undefined,
              style: { direction: type === "tel" ? "rtl" : undefined },
            }}
            InputLabelProps={{
              style: {
                textAlign: "right",
                position: "absolute",
                right: "0",
                width: "100%",
                direction: "rtl",
                color: "black",
                transform: "unset",
              },
            }}
          />
        </>
      )}
    />
  );
};
